import { render, staticRenderFns } from "./dwdata.vue?vue&type=template&id=44af91f3&"
import script from "./dwdata.vue?vue&type=script&lang=js&"
export * from "./dwdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports